<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">회원점수현황</h5>
        <div
          class="sub_title"
          style="
            margin-bottom: 20px;
            color: #333;
            font-size: 13px;
            border: 1px solid #ccc;
            background: #f8f8f8;
            height: 30px;
            text-align: right;
            position: absolute;
            right: 20px;
            top: 10px;
            padding: 4px 10px 2px 10px;
          "
        >
          학습점수관리 → 회원점수현황
        </div>
        
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
           
              <td scope="row" style="text-align: center">
                <PointView :PointView="record" :ref="'pointN'+record.id" />
                {{ record.id }}
              </td>
              <td style="text-align: center">{{ record.username }}</td>
              <td style="text-align: center">   <Student :student="record" /></td>
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >                
                <Business v-if="record.t2" :biz="record.t2" />
              </td>

              <td style="text-align: center;width:23%">
                <Business v-if="record.t1" :biz="record.t1" />
              </td>             
              
              <td style="text-align: center;width:10%">
                <template v-if="record.fame == 'N/A'">사용할 수 없음</template
                ><template v-else>{{
                  parseInt(record.fame).toLocaleString()
                }}</template>
              </td>
              <td style="text-align: center;width:10%">
                <template v-if="record.alpha == 'N/A'">사용할 수 없음</template
                ><template v-else>{{
                  parseInt(record.alpha).toLocaleString()
                }}</template>
              </td>
              <td style="text-align: center;width:10%">
                <template v-if="record.carat == 'N/A'">사용할 수 없음</template
                ><template v-else>{{
                  parseInt(record.carat).toLocaleString()
                }}</template>
              </td>
              <td>
              <button
                class="btn btn-warning btn-sm"
                @click="this.$refs['pointN'+record.id][0].openModal()"
              >
                관리
              </button>                
            </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Business from "../components/Business";
import Student from "../components/detail_pages/Student";
import QueryGrid from "../components/QueryGrid";
import PointView from "../components/detail_pages/PointInsert";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Business,
    Student,
    QueryGrid,
    PointView,
  },
  mounted() {
    

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.config.columns.splice(1, 1);
    }

    this.$refs.qg.search();
  },
  methods: {
    
  },
  data() {
    return {
      config: {
        name: "회원점수현황",
        req_endpoint: "/students/pointMemList",
        default_limit: 20,
       
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
         
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder:
              "아이디/이름/회원번호/튜터명/학원/클래스/담당교사/레벨",
          },
        ],
        columns: [
         
          
          {
            id: "id",
            sortable: true,
            name: "회원번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "biz",
            sortable: true,
            name: "학원/캠퍼스",
            excel_print: (v) => {
              return v.t2.name;
            },
          },
          {
            id: "class",
            sortable: true,
            name: "클래스",
            excel_print: (v) => {
              return v.t1.name;
            },
          },
          
          {
            id: "fame",
            sortable: true,
            name: "Fame",
            excel_print: (v) => {
              return v.fame || "";
            },
          },
          {
            id: "alpha",
            sortable: true,
            name: "Alpha",
            excel_print: (v) => {
              return v.alpha || "";
            },
          },
          {
            id: "carat",
            sortable: true,
            name: "Carat",
            excel_print: (v) => {
              return v.carat || "";
            },
          },
          {
          id: "action",
          name: "비고",
          },
        ],
        disable_init_search: true,
      },
    };
  },
};
</script>
